import React from "react";

import "./halo.css";

/** Racine des pages de l'app, posée sur le fond « Halo » (voir halo.css). */
const Halo = ({ children }) => (
  <div className="wosh-halo">
    <div className="wosh-halo__layer" aria-hidden="true" />
    {children}
  </div>
);

export default Halo;
